<template>
	<div>
		<div class="container container-tabs">


			<el-tabs v-model="activeName" @tab-click="handleClick" type="card">

				<el-tab-pane name="all" class="to-searh">
					<span slot="label" class="table-title">全部</span>
				</el-tab-pane>

				<el-tab-pane :name="String(item.val)" v-for="(item, index) in status_data" :key="index" class="to-searh">
					<span slot="label" class="table-title">{{ item.alias }}</span>
				</el-tab-pane>


				<div class="handle-box">


					<el-row class="head-search">
						<el-col :span="8">
							<span class="title">用户名:</span>
							<el-input v-model="search_data.user_name" placeholder="请输入用户名" class="handle-input mr10" maxlength="30"
								@keyup.enter.native="searchAdminLists">
							</el-input>
						</el-col>

						<el-col :span="8">
							<span class="title">手机号码:</span>
							<el-input v-model="search_data.phone" placeholder="请输入手机号码" class="handle-input mr10"
								@keyup.enter.native="searchAdminLists"></el-input>

						</el-col>

						<el-col :span="6">
							<el-button :class="more_search?'el-icon-arrow-up':'el-icon-arrow-down'"
								@click="more_search = !more_search">
								详细搜索
							</el-button>
						</el-col>

					</el-row>





					<div v-show="more_search" style="margin-top: 10px;">






						<el-row class="head-search">

							<el-col :span="24">
								<span class="title">昵称:</span>
								<el-input v-model="search_data.name" placeholder="请输入昵称 " class="handle-input mr10"
									@keyup.enter.native="searchAdminLists"></el-input>
							</el-col>

						</el-row>





						<el-row class="head-search">

							<el-col :span="24" style="margin: 10px 0;">
								<span class="title">是否锁定:</span>
								<el-radio-group v-model="search_data.locking" size="small">
									<el-radio label="" border>
										全部</el-radio>
									<el-radio v-for="(item, index) in locking_data" :key="index" :label="String(item.val)" border>
										{{ item.alias }}</el-radio>
								</el-radio-group>
							</el-col>

						</el-row>


					</div>
				</div>

				<div>
					<el-button type="primary" icon="el-icon-search" @click="searchAdminLists">搜索</el-button>

					<el-button @click="addAdminDialogShow = !addAdminDialogShow">添加</el-button>

					<el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
				</div>

			</el-tabs>







			<el-table :data="result_data.data" class="table" ref="multipleTable" header-cell-class-name="table-header"
				@selection-change="handleSelectionChange">

				<el-table-column type="selection" width="55" align="center" prop="admin_role_code"></el-table-column>

				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">

							<div class="more-style">
								<el-form-item label="编号：">
									<span>{{ props.row.id }}</span>
								</el-form-item>

								<el-form-item label="管理员名称：">
									<span>{{ props.row.name }}</span>

								</el-form-item>

								<el-form-item label="用户名：">
									<span>{{ props.row.user_name }}</span>
								</el-form-item>
							</div>

							<div class="more-style">
								<el-form-item label="手机号码：">
									<span>{{ props.row.phone }}</span>
								</el-form-item>

								<el-form-item label="城市名称:">
									<span @click="city_isShow(props.row.city.city_code); edit_city_dialog_data = props.row.city.city_code"
										style="cursor: pointer;color: cornflowerblue" v-if="props.row.city.city_code.length>0">
										{{ props.row.city.name }}
									</span>
									<span @click="show_or_hidden" style="cursor: pointer;color: cornflowerblue" v-else>
										{{ props.row.city.name }}
									</span>
								</el-form-item>
								<el-form-item label="解封时间：">
									<span>{{ props.row.ban_time.YmdHis }}</span>
								</el-form-item>

							</div>

							<div class="more-style">
								<el-form-item label="管理员状态：">
									<span>{{ user_status }}</span>
								</el-form-item>

								<el-form-item label="是否锁定：">
									<span>{{ props.row.locking.alias }}</span>
								</el-form-item>

								<el-form-item label="验证阈值：">
									<span>{{ props.row.verify.alias }}</span>
								</el-form-item>
							</div>

							<div class="more-style">
								<el-form-item label="注册时间：">
									<span>{{ props.row.reg_time.YmdHis }}</span>
								</el-form-item>
							</div>

						</el-form>
					</template>
				</el-table-column>

				<el-table-column label="id" prop="id" min-width="80"></el-table-column>

				<el-table-column label="昵称" prop="name" min-width="150"></el-table-column>

				<el-table-column label="用户名" min-width="150">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="bottom">
							<p>角色编码: {{ scope.row.admin_code }}</p>
							<div slot="reference">
								<el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.user_name }}
								</el-tag>
							</div>
						</el-popover>
					</template>
				</el-table-column>

				<el-table-column label="电话" prop="phone" min-width="150"></el-table-column>

				<el-table-column label="锁定">
					<template slot-scope="scope">
						<el-tag :type="scope.row.locking.val == '1' ? '' : (scope.row.locking.val == '0' ?'warning' : 'danger')">
							{{scope.row.locking.alias }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="用户状态">
					<template slot-scope="scope">
						<el-tag :type="scope.row.status.val == '1' ? '' : (scope.row.status.val == '2' ?'danger' : 'warning')">
							{{scope.row.status.alias}}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="注册时间">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="bottom">
							<p>详细时间: {{ scope.row.reg_time.YmdHis }}</p>
							<div slot="reference">
								<el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.reg_time.Ymd }}
								</el-tag>
							</div>
						</el-popover>
					</template>
				</el-table-column>

				<el-table-column label="操作" min-width="180">
					<template slot-scope="scope">
						<el-button size="mini" type="primary"
							@click="editRoleSubmitShow =!editRoleSubmitShow; editRole_data=scope.row.admin_code">
							编辑
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 批量删除按钮 -->
			<el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
				style="margin-top: 20px;">批量删除</el-button>

			<!-- 分页组件 -->
			<div class="pagination">
				<pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
			</div>

			<!-- 用户添加弹窗 -->
			<addAdminSubmit :isShow="addAdminDialogShow" @submit_ok_return="pages_function"></addAdminSubmit>

			<!-- 用户编辑弹窗 -->
			<editAdminSubmit :isShow="editRoleSubmitShow" :editRole_data="editRole_data" @submit_ok_return="pages_function">
			</editAdminSubmit>



		</div>
	</div>
</template>
<script>
	var _this;
	// 引入子组件
	import addAdminSubmit from '../admin/addAdminSubmit';
	import editAdminSubmit from '../admin/editAdminSubmit';


	export default {
		// 注册子组件
		components: {

			addAdminSubmit,
			editAdminSubmit,
		},

		data() {
			return {

				// 是否冻结
				status: '',




				// 是否锁定
				locking: '',

				// 详细搜索变量
				more_search: false,

				// 选项卡默认选中项
				activeName: 'all',


				// 编辑城市传递的数据
				edit_city_dialog_data: '',

				// 用户状态
				status_data: [],
				// 是否锁定
				locking_data: [],
				// 管理员状态
				user_status: 0,

				// 向子组件传的值
				editRole_data: '',

				// 添加页面
				addAdminDialogShow: false,

				// 编辑页面
				editRoleSubmitShow: false,

				// 编辑城市
				edit_city_isShow: false,

				search_data: {
					page: 1,
					limit: 10,
					admin_role_code: '',
					user_name: '',
					name: '',
					phone: '',
					locking: '',
					status: '',
					verify: '',
				},
				search_rules: {
					page: {
						placeholder: '页码',
						rules: {
							required: true,
							message: '页码需要大于0',
							regulation: 'gt',
							rulesData: 0
						}
					},
					limit: {
						placeholder: '每页个数',
						rules: {
							required: true,
							message: '每页个数需在1-51之内',
							regulation: 'between',
							rulesData: [1, 51]
						}
					},
					user_name: {
						placeholder: '搜索的角色名称',
						rules: {
							required: false,
							message: '角色名称需在10汉字之内',
							regulation: 'elt_str',
							rulesData: 30
						}
					}
				},

				delRoleSubmit_data: {
					admin_code_array: []
				},

				delRoleSubmit_rules: {
					admin_code_array: {
						placeholder: '权限模块',
						rules: {
							required: false,
							message: '权限模块代码数组(json)',
							regulation: 'special',
							rulesData: 'json_array'
						}
					}
				},
				result_data: [],
			};
		},




		//生命周期，建立
		created() {

			_this = this;

			//初始化显示列表
			_this.adminLists();

			switch (_this.user_status) {

				case 0:

					_this.user_status = '待激活';

					break;

				case 1:

					_this.user_status = '正常';

					break;

				case 2:

					_this.user_status = '已禁封';

					break;
			}

		},
		methods: {





			searchAdminLists() {

				_this.search_data.page = 1;

				_this.adminLists();

			},

			// 选项卡选中事件
			handleClick(tab, event) {
				// 点击的选项卡所对应的val值

				if (tab.name != 'all') {
					_this.search_data.status = tab.name;
				} else {
					_this.search_data.status = '';
				}
				_this.search_data.page = 1;
				_this.adminLists();

			},

			show_or_hidden() {
				_this.$message.error('城市名称无内容,无法编辑')
			},
			city_isShow(val) {

				_this.edit_city_isShow = !_this.edit_city_isShow;

			},
			// 详细搜索里 是否锁定change事件
			selectLocking(val) {

				_this.search_data.locking = val.toString();

			},
			// 详细搜索里 用户状态change事件
			searchStatus(val) {

				_this.search_data.status = val.toString();


			},


			// table表格选中事件
			handleSelectionChange(val) {

				var datalist = [];

				for (var i in val) {

					datalist.push(val[i].admin_code);

				}
				// 将选中的数据赋给admin_code_array
				_this.delRoleSubmit_data.admin_code_array = datalist;
			},

			// 批量删除
			deleteData() {

				// 如果未勾选任何一条数据  弹窗提醒用户   至少勾选一条数据
				if (_this.delRoleSubmit_data.admin_code_array.length == 0) {

					_this.$message.warning('请至少勾选一条数据');

					return;
				}


				_this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

					confirmButtonText: '确定',

					cancelButtonText: '取消',

					type: 'warning',

				}).then(() => {
					// 将admin_code_array转换成json格式数据
					_this.delRoleSubmit_data.admin_code_array = JSON.stringify(_this.delRoleSubmit_data.admin_code_array);

					_this.$post(
						"/system/delAdminSubmit",
						_this.delRoleSubmit_data,
						_this.delRoleSubmit_rules
					).then(res => {

						_this.$message.success('删除成功!');

						//初始化显示列表
						_this.adminLists();

					}).catch((err) => {

					})

				}).catch(() => {

					_this.$message.info('已取消删除');

				});

			},
			//翻页组件的回调
			pages_function(search_data) {

				//赋值
				_this.search_data = search_data;

				//初始化
				_this.adminLists();


			},

			//搜索角色列表
			adminLists() {

				_this.$post(
					"/system/adminLists",
					_this.search_data,
				).then(res => {

					_this.result_data = res;

					// 搜索用户状态
					_this.status_data = _this.result_data.data[0].status.select_array

					// 搜索是否锁定
					_this.locking_data = _this.result_data.data[0].locking.select_array

				}).catch((err) => {

				})

			},
			// 刷新页面
			refresh() {
				this.$router.go(0);
			}

		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 188px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>
